import * as angular from 'angular';

const MAX_LENGTH = 15;

function trimStartFilter() {
    return function(input: any) {
        if (typeof input === 'string') {
            if (!input || input.length <= MAX_LENGTH) {
                return input;
            }

            return `...${input.substr(input.length - MAX_LENGTH)}`;
        }

        return null;
    };
}

angular
    .module('app.common')
    .filter('trimstart', trimStartFilter);



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/app.retailer.common/modules/filters/trim-start.filter.ts